import { Loader, Paper, Stack, Text } from '@mantine/core';

import MaxWidthLayout from './MaxWidthLayout';

interface LoadingFallBackProps {
    message?: string;
    wrapInMaxWidth?: boolean;
}

export const LoadingFallBack = ({
    message,
    wrapInMaxWidth = true
}: LoadingFallBackProps) => {
    const loadingContent = (
        <Paper radius={'md'} p={'md'} shadow={'md'}>
            <Stack gap={'md'} align={'center'}>
                <Text fw={600} size={'md'}>
                    {message ?? 'Loading'}
                </Text>
                <Loader color={'gray.6'} size='lg' type='dots' />
            </Stack>
        </Paper>
    );

    return wrapInMaxWidth ? (
        <MaxWidthLayout>{loadingContent}</MaxWidthLayout>
    ) : (
        loadingContent
    );
};
